import type { ComponentProps } from "react";
import { IconPlus } from "@tabler/icons-react";
import Button from "../UI/Button";
// @ts-expect-error pure js
import { classnames } from "../../utils";
import styles from "./EdlAddButton.module.css";

type EdlAddButtonProps = Omit<
  ComponentProps<typeof Button>,
  "variant" | "icon" | "type"
>;

/** Bouton d'ajout pleine largeur en pointillés (élément, sous-élément). */
export default function EdlAddButton({
  className,
  ...props
}: EdlAddButtonProps) {
  return (
    <Button
      type="button"
      variant="secondary"
      icon={IconPlus}
      className={classnames(styles.button, className)}
      {...props}
    />
  );
}
